module.exports = __webpack_public_path__ + "img/9.0a27cb3f.png";